/** "4.13" / "4.13.1"; boş geçerli (kontrol kapalı). Sunucu da aynı kuralı uygular (MobilSurumHesap). */
export const surumGecerli = (s?: string) => !s || /^\d{1,4}(\.\d{1,4}){1,3}$/.test(s.trim());
